export enum BaseProductsStatusEnum {
  NOT_ALLOWED_SENDING = 0,
  ALLOWED_SENDING = 1,
  ERROR = 2,
  SUCCESS = 3
}
